import { c as _c } from "react/compiler-runtime";
import type { IconProps } from '../types';
const IcoDiners16 = t0 => {
  const $ = _c(7);
  const {
    "aria-label": ariaLabel,
    className
  } = t0;
  let t1;
  let t2;
  let t3;
  let t4;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <path d="M9.20169 13.5962C12.2331 13.6109 15 11.1013 15 8.04836C15 4.71012 12.2331 2.40238 9.20169 2.40363H6.59271C3.52518 2.40238 1 4.71074 1 8.04836C1 11.1019 3.52518 13.6109 6.59271 13.5962H9.20169Z" fill="#0079BE" />;
    t2 = <path d="M6.60489 2.86627C3.80152 2.86721 1.53023 5.15999 1.5293 7.98983C1.53023 10.8194 3.80152 13.1121 6.60489 13.1131C9.40856 13.1121 11.6808 10.8194 11.6811 7.98983C11.6808 5.15999 9.40887 2.86721 6.60489 2.86627ZM3.38782 7.98983C3.38723 7.33555 3.58404 6.69631 3.95252 6.15565C4.321 5.61499 4.84401 5.19807 5.4532 4.95937V11.02C4.84396 10.7815 4.32088 10.3646 3.95239 9.82398C3.58389 9.28336 3.38712 8.6441 3.38782 7.98983ZM7.75626 11.0212V4.95906C8.36591 5.19742 8.88937 5.6143 9.25812 6.15514C9.62687 6.69598 9.82371 7.33556 9.82288 7.99015C9.82359 8.6447 9.62669 9.28422 9.25796 9.82504C8.88923 10.3659 8.36583 10.7828 7.75626 11.0212Z" fill="#fff" />;
    t3 = <path d="M9.20169 13.5962C12.2331 13.6109 15 11.1013 15 8.04836C15 4.71012 12.2331 2.40238 9.20169 2.40363H6.59271C3.52518 2.40238 1 4.71074 1 8.04836C1 11.1019 3.52518 13.6109 6.59271 13.5962H9.20169Z" fill="#0079BE" />;
    t4 = <path d="M6.60489 2.86627C3.80152 2.86721 1.53023 5.15999 1.5293 7.98983C1.53023 10.8194 3.80152 13.1121 6.60489 13.1131C9.40856 13.1121 11.6808 10.8194 11.6811 7.98983C11.6808 5.15999 9.40887 2.86721 6.60489 2.86627ZM3.38782 7.98983C3.38723 7.33555 3.58404 6.69631 3.95252 6.15565C4.321 5.61499 4.84401 5.19807 5.4532 4.95937V11.02C4.84396 10.7815 4.32088 10.3646 3.95239 9.82398C3.58389 9.28336 3.38712 8.6441 3.38782 7.98983ZM7.75626 11.0212V4.95906C8.36591 5.19742 8.88937 5.6143 9.25812 6.15514C9.62687 6.69598 9.82371 7.33556 9.82288 7.99015C9.82359 8.6447 9.62669 9.28422 9.25796 9.82504C8.88923 10.3659 8.36583 10.7828 7.75626 11.0212Z" fill="#fff" />;
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
    $[3] = t4;
  } else {
    t1 = $[0];
    t2 = $[1];
    t3 = $[2];
    t4 = $[3];
  }
  let t5;
  if ($[4] !== ariaLabel || $[5] !== className) {
    t5 = <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label={ariaLabel} className={className} role="img" data-colored={true}>{t1}{t2}{t3}{t4}</svg>;
    $[4] = ariaLabel;
    $[5] = className;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  return t5;
};
export default IcoDiners16;